/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _shallowequal = _interopRequireDefault(require("../../packages/shallowequal"));
var _default = function _default(inst, nextProps, nextState) {
  var props = inst.props;
  var state = inst.state;
  if (nextProps.shouldComponentUpdate) {
    return nextProps.shouldComponentUpdate({
      nextProps: nextProps,
      props: props,
      nextState: nextState,
      state: state
    });
  }
  return !(0, _shallowequal.default)(nextProps, props) || !(0, _shallowequal.default)(nextState, state);
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/shouldComponentUpdate/index.js
// module id = 56
// module chunks = 0